import { useState } from "react";

import { DropZone, type DropZoneConfigProps } from "./DropZone";
import {
  FileUploadWrapper,
  type FileUploadWrapperProps,
} from "./FileUploadWrapper";
import type { DragFile, UploadState } from "./uploadUtils";

type FileChooserDropzoneTriggerProps = Omit<
  FileUploadWrapperProps,
  "setUploadState" | "setDraggedOverFiles" | "children"
> & { dropzoneProps?: DropZoneConfigProps; onClick?: () => void };

export const FileChooserDropzoneTrigger = ({
  allowMultiple,
  accept,
  dropzoneProps = {},
  onClick,
  ...rest
}: FileChooserDropzoneTriggerProps) => {
  const [draggedOverFiles, setDraggedOverFiles] = useState<Array<DragFile>>([]);
  const [uploadState, setUploadState] = useState<UploadState>({
    isUploading: false,
    uploadProgress: 0,
  });

  return (
    <FileUploadWrapper
      setUploadState={setUploadState}
      setDraggedOverFiles={setDraggedOverFiles}
      accept={accept}
      allowMultiple={allowMultiple}
      {...rest}
    >
      <DropZone
        uploadState={uploadState}
        setUploadState={setUploadState}
        draggedOverFiles={draggedOverFiles}
        allowMultiple={allowMultiple}
        accept={accept}
        onClick={onClick}
        {...dropzoneProps}
      />
    </FileUploadWrapper>
  );
};
